import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { Asociado, BASE_PATH } from '../../api';
import { AuthService } from './auth.service';

/**
 * Asociados de UNA asociación en un ejercicio (GET /asociaciones/{id}/asociados?ejercicio=). El cliente generado no declara el
 * parámetro `ejercicio`; sin él la API usa el año NATURAL, que puede no ser el ejercicio vigente (2027 durante 2026).
 */
@Injectable({ providedIn: 'root' })
export class AsociacionAsociadosService {
  constructor(
    private readonly http: HttpClient,
    private readonly auth: AuthService,
    @Inject(BASE_PATH) private readonly basePath: string
  ) {}

  listar(asociacionId: number, ejercicio?: number | null): Observable<Asociado[]> {
    const headers = new HttpHeaders({ Authorization: 'Bearer ' + this.auth.getToken() });
    const consulta = ejercicio ? `?ejercicio=${encodeURIComponent(String(ejercicio))}` : '';
    return this.http
      .get<{ asociados?: Asociado[] }>(`${this.basePath}/asociaciones/${encodeURIComponent(String(asociacionId))}/asociados${consulta}`, { headers })
      .pipe(map(res => res?.asociados ?? []));
  }
}
